export default "__VITE_PUBLIC_ASSET__252b81cf__"